import { render, staticRenderFns } from "./createDiscountType.vue?vue&type=template&id=69040e3c&"
import script from "./createDiscountType.vue?vue&type=script&lang=js&"
export * from "./createDiscountType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports